import { AddTemplateDetailsData } from "@app/admin/manage-specialties/specialty";
import { TemplateDetailsData } from "@app/admin/manage-specialties/templateDetailsData";
import { TemplateMetadataModel } from "@app/admin/manage-templates";
import { MinimalUser } from "@app/admin/user-administration/minimalUser";
import ServiceBase from "@app/shared/serviceBase";

export default class SpecialtyService extends ServiceBase {

  private authenticationApiEndpoint = `${this.apiEndpoint}`;

  public async getTemplateDetails(templateCollectionId: number, templateId: string): Promise<TemplateDetailsData> {
    const data = await this.makeGet<TemplateDetailsData>(`/templates/${templateCollectionId}/template/${templateId}/details`, null, this.authenticationApiEndpoint);
    return data;
  }

  public async addTemplateVersion(templateCollectionId: number, model: AddTemplateDetailsData): Promise<TemplateMetadataModel> {
    const data = await this.makePost<TemplateMetadataModel>(`/templates/${templateCollectionId}/template/addjson`,model, this.authenticationApiEndpoint,false, "application/json");
    return data;
  }

  public getTemplateDetailsJSONFile(templateCollectionId: number, templateId: string): string{
    return `${this.authenticationApiEndpoint}/templates/${templateCollectionId}/template/${templateId}/details/file`;
  }

  public getTemplateDetailsXLSXFile(templateCollectionId: number, templateId: string): string{
    return `${this.authenticationApiEndpoint}/templates/${templateCollectionId}/template/${templateId}/sheet`;
  }

  public async getUsersAuthorizedForEdit(clientId: number): Promise<MinimalUser[]> {
    return await this.makeGet<MinimalUser[]>(`/manage-templates/clients/${clientId}/authorized-users`, null, this.authenticationApiEndpoint);
  }

  public async postTemplateDetails(templateCollectionId: number, model: TemplateDetailsData): Promise<TemplateDetailsData> {
    return await this.makePost<TemplateDetailsData>(`/templates/${templateCollectionId}/template/addjson`, model, this.authenticationApiEndpoint)
  }
}
